import api from "../../utils/api/authApi";
import {
  ADD_PET,
  BOOKING,
  DELETE_THERAPY,
  FILE_DELETE,
  PET_NOTE_DELETE,
  SPECIES_ACTIVATION,
  SPECIES_DELETE,
  TEMPLATE,
} from "../ApiPaths";

export async function deleteCore(url, id, params = {}) {
  const path = id ? url + id : url;
  try {
    await api.delete(path, { params: params });
  } catch (error) {
    throw error;
  }
}

export async function deleteFile(id) {
  const url = FILE_DELETE;
  await deleteCore(url, id);
}

export async function deleteTemplate(id, userId) {
  const path = TEMPLATE + `${id}` + "?userId=" + userId;
  await deleteCore(path);
}

export async function deleteAppointment(id, userId) {
  const url = BOOKING + `${id}` + "?userId=" + userId;
  await deleteCore(url);
}

export async function deletePet(id) {
  const url = ADD_PET;
  await deleteCore(url, id);
}

export async function deleteTherapy(id) {
  const url = DELETE_THERAPY;
  await deleteCore(url, id);
}

export async function speciesActivation(id) {
  const url = SPECIES_ACTIVATION;
  await deleteCore(url, id);
}

export async function deleteSpecies(id) {
  const url = SPECIES_DELETE;
  await deleteCore(url, id);
}

export async function deletePetNote(id) {
  const url = PET_NOTE_DELETE;
  await deleteCore(url, id);
}
